import { render, staticRenderFns } from "./BecomeAnAgent.vue?vue&type=template&id=7afafa33&scoped=true&"
import script from "./BecomeAnAgent.vue?vue&type=script&lang=js&"
export * from "./BecomeAnAgent.vue?vue&type=script&lang=js&"
import style0 from "./BecomeAnAgent.vue?vue&type=style&index=0&id=7afafa33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afafa33",
  null
  
)

export default component.exports